import React from 'react';
import c from 'classnames';
// import { useTranslation } from 'react-i18next';
import s from './InputLabelText.scss';
/**
 * The text of an `<input />`'s label.
 *
 * NOTE: You still need need to wrap this in an `<InputLabel />` tag! This just provides the necessary styling to the text.
 */ const InputLabelText = ({ children , className , isRequired , onClick ,  })=>{
    // const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], className),
        onClick: onClick
    }, children, ' ', isRequired && /*#__PURE__*/ React.createElement("span", {
        className: s['required-text'],
        "aria-hidden": "true"
    }, "*Required"));
};
InputLabelText.displayName = 'InputLabelText';
export default InputLabelText;
